/**
 * @licence
 * Copyright 2021 ModBros OG
 * Licenced under apache Licence, Version 2.0
 */

/**
 * Do not edit directly!
 * Generated on Wed Oct 13 2021 19:02:58 GMT+0200 (Central European Summer Time)
 */

export const Layer = {
  Primer: 'var(--modbros-color-layer-primer, hsl(240, 11%, 10%))',
  Background: 'var(--modbros-color-layer-background, hsl(240, 11%, 14%))',
  Default: 'var(--modbros-color-layer-default, hsl(240, 11%, 17%))',
  Highlight: 'var(--modbros-color-layer-highlight, hsl(240, 11%, 20%))'
};
export const Container = {
  Background: 'var(--modbros-color-container-background, hsl(240, 11%, 14%))',
  Default: 'var(--modbros-color-container-default, hsl(240, 11%, 23%))',
  Highlight: 'var(--modbros-color-container-highlight, hsl(240, 11%, 25%))',
  Brand: 'var(--modbros-color-container-brand, hsl(359, 77%, 64%))',
  Overlay: 'var(--modbros-color-container-overlay, hsla(240, 18%, 11%, 0.8))',
  Input: 'var(--modbros-color-container-input, hsl(240, 11%, 29%))',
  InputHover: 'var(--modbros-color-container-input-hover, hsl(240, 13%, 35%))',
  InputDisabled: 'var(--modbros-color-container-input-disabled, hsl(240, 3%, 23%))'
};
export const Action = {
  Standard: {
    Default: 'var(--modbros-color-action-standard-default, hsl(240, 16%, 42%))',
    DefaultHover: 'var(--modbros-color-action-standard-default-hover, hsl(240, 16%, 35%))',
    DefaultDisabled: 'var(--modbros-color-action-standard-default-disabled, hsl(0, 0%, 30%))'
  },
  Primary: {
    Default: 'var(--modbros-color-action-primary-default, hsl(8, 60%, 50%))',
    DefaultHover: 'var(--modbros-color-action-primary-default-hover, hsl(8, 60%, 42%))',
    DefaultDisabled: 'var(--modbros-color-action-primary-default-disabled, hsl(8, 22%, 35%))'
  },
  Minimal: {
    Default: 'var(--modbros-color-action-minimal-default, hsla(0, 0%, 0%, 0))',
    DefaultHover: 'var(--modbros-color-action-minimal-default-hover, hsla(240, 12%, 10%, 0.66))',
    DefaultDisabled: 'var(--modbros-color-action-minimal-default-disabled, hsla(0, 0%, 21%, 0.66))'
  },
  Critical: {
    Default: 'var(--modbros-color-action-critical-default, hsl(3, 100%, 60%))',
    DefaultHover: 'var(--modbros-color-action-critical-default-hover, hsl(3, 100%, 56%))',
    DefaultDisabled: 'var(--modbros-color-action-critical-default-disabled, hsl(3, 25%, 55%))'
  },
  Success: {
    Default: 'var(--modbros-color-action-success-default, hsl(150, 75%, 40%))',
    DefaultHover: 'var(--modbros-color-action-success-default-hover, hsl(150, 75%, 36%))',
    DefaultDisabled: 'var(--modbros-color-action-success-default-disabled, hsl(150, 10%, 50%))'
  }
};
export const Text = {
  Default: 'var(--modbros-color-text-default, hsl(240, 12%, 80%))',
  Action: {
    Default: 'var(--modbros-color-text-action-default, hsl(200, 95%, 66%))',
    DefaultHover: 'var(--modbros-color-text-action-default-hover, hsl(200, 100%, 70%))',
    DefaultActive: 'var(--modbros-color-text-action-default-active, hsl(200, 75%, 55%))'
  },
  Emphasized: 'var(--modbros-color-text-emphasized, hsl(0, 0%, 100%))',
  OnColor: 'var(--modbros-color-text-on-color, hsl(240, 10%, 100%))',
  OnColorContrast: 'var(--modbros-color-text-on-color-contrast, hsl(240, 10%, 10%))',
  Brand: 'var(--modbros-color-text-brand, hsl(8, 60%, 50%))',
  Disabled: 'var(--modbros-color-text-disabled, hsl(240, 4%, 55%))',
  Error: 'var(--modbros-color-text-error, hsl(3, 100%, 60%))',
  Success: 'var(--modbros-color-text-success, hsl(150, 75%, 40%))',
  Warning: 'var(--modbros-color-text-warning, hsl(32, 100%, 55%))'
};
export const Border = {
  Default: 'var(--modbros-color-border-default, hsla(240, 14%, 50%, 0.3))',
  Active: 'var(--modbros-color-border-active, hsl(0, 0%, 100%))',
  Disabled: 'var(--modbros-color-border-disabled, hsl(240, 4%, 33%))',
  Focused: 'var(--modbros-color-border-focused, hsl(200, 95%, 66%))',
  Error: 'var(--modbros-color-border-error, hsl(3, 100%, 60%))',
  Success: 'var(--modbros-color-border-success, hsl(150, 75%, 40%))'
};
export const Gradient = {
  Default: 'var(--modbros-color-gradient-default, linear-gradient(90deg, #3F3F5A 0%, #303040 100%))',
  Brand: 'var(--modbros-color-gradient-brand, linear-gradient(90deg, #FF3300 0%, #B6075E 100%))'
};
export default {
  Layer,
  Container,
  Action,
  Text,
  Border,
  Gradient,
}